import React from 'react';

import CoachingSelfServeView from 'coaching/components/CoachingSelfServeView/CoachingSelfServeView';
import CoachingStripeContainer from './components/CoachingStripeContainer';

export default function CoachingSelfServeContainer() {
  return (
    <CoachingStripeContainer>
      <CoachingSelfServeView />
    </CoachingStripeContainer>
  );
}
